export default __webpack_public_path__ + "static/media/640_dummy2016-streetfashion01-de.4ea47773.png";